import React from 'react';
import {AvForm} from 'availity-reactstrap-validation';
import Loading from "../../shared/component/others/Loading";
import DataTable from "../../shared/component/dataTable/DataTable";
import SaleReportColumn from "../../shared/component/dataTable/columns/SaleReportColumn.json";
import {Button} from "reactstrap";
import Translate from "../../shared/language/Translate";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import './SaleReportPage.css';
import '../../shared/styles/SettingsPage.css';

export default class SaleReportDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            loading: false
        };
    }

    componentDidMount() {

    }


    render() {
        return (
            <div className="sale-report-page__dialog">
                <AvForm>
                    {this.renderReport()}
                </AvForm>
                {this.state.loading && <Loading/>}
            </div>
        );
    }

    exportPdf = () => {
        this.refDataTable.exportPdf();
    }

    sendEmail = () => {
        this.refDataTable.sendEmail();
    }

    renderReport() {
        return (
            <div>
                <div className="sale-report-page__toolbar settings-page__actions settings-page__actions--inline">
                    <Button color="outline-primary" className="settings-page__btn--action" onClick={this.exportPdf}>
                        <i className="pi pi-file-pdf" aria-hidden="true"/>
                        <Translate contentKey="entity.action.pdf">Export To PDF</Translate>
                    </Button>
                    <Button color="outline-primary" className="settings-page__btn--action" onClick={this.sendEmail}>
                        <i className="pi pi-send" aria-hidden="true"/>
                        <Translate contentKey="entity.action.email">Send Email</Translate>
                    </Button>
                </div>

                <div className="sale-report-page__table-wrap sale-report-page__report-table">
                    <DataTable
                        fields={SaleReportColumn.fields}
                        refresh={false}
                        ref={(elem) => this.refDataTable = elem}
                        objectName={SaleReportColumn.name}
                        rows={100}
                        reportName="Sale Report"
                        paginator={false}
                        parameter={!GeneralUtils.isNullOrEmpty(this.state.id) ? this.state.id : null}
                        dataURL={!GeneralUtils.isNullOrEmpty(this.state.id) ? "reporting/zxreport/salereport/" + this.state.id : null}
                        selectionMode="single"
                        loading={this.state.loading}/>
                </div>

                <div className="sale-report-page__dialog-footer settings-page__actions settings-page__actions--inline">
                    <Button
                        color="outline-primary"
                        className="settings-page__btn--cancel settings-page__btn--close"
                        onClick={() => this.props.closeDisplayDialog()}>
                        <Translate contentKey="entity.action.cancel">Close</Translate>
                    </Button>
                </div>
            </div>
        );
    }

    setData = (data) => {
        this.setState({
            id: data.id
        }, () => {
            this.refDataTable.refresh(data.id);
        });

    }

}
